import { render, staticRenderFns } from "./PositionTemplateEditor.vue?vue&type=template&id=bfebc73e&scoped=true&"
import script from "./PositionTemplateEditor.vue?vue&type=script&lang=js&"
export * from "./PositionTemplateEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfebc73e",
  null
  
)

export default component.exports